import React, { FC, useState, useEffect, useRef } from 'react';
import { ReactComponent as CloseIcon } from '../../../icons/close-modal.svg';
import { ReactComponent as PlusAddIcon } from '../../../icons/plus-add.svg';

import './add-todo-modal.scss';

interface DelegateTaskModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (additionalInfo: string) => void;
  taskDescription: string;
  agentNickname: string;
}

const DelegateTaskModal: FC<DelegateTaskModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  taskDescription,
  agentNickname,
}) => {
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setInputValue('');
    }
  }, [isOpen]);

  const handleSubmit = () => {
    onSubmit(inputValue.trim());
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
    if (e.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className='add-todo-modal-container delegate'>
      <div className='add-todo-modal'>
        <div className='modal-header'>
          <h1 className='modal-title'>Give more information</h1>
        </div>
        <div className='modal-body'>
          <p className='delegate-subtitle'>
            If you think {agentNickname} might need more information to do this
            task, give it here.
          </p>
          <div className='delegate-task-description'>{taskDescription}</div>
          <div className='todo-input-wrapper'>
            <textarea
              ref={inputRef}
              className='todo-input'
              placeholder='Any extra context... (optional)'
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
                e.target.style.height = '0px';
                e.target.style.height = `${e.target.scrollHeight}px`;
              }}
              onKeyDown={handleKeyDown}
              rows={1}
            />
          </div>
          <div className='action-bar'>
            <div className='action-buttons-left' />
            <button className='create-btn' onClick={handleSubmit}>
              <PlusAddIcon />
              {inputValue.trim() ? 'Delegate with context' : 'Delegate'}
            </button>
          </div>
        </div>
      </div>
      <button className='close-btn' onClick={onClose}>
        <CloseIcon />
      </button>
    </div>
  );
};

export default DelegateTaskModal;
